import { projectsId, type ProjectsId } from "./Projects";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for environments */
export type EnvironmentsId = string & { __flavor: "EnvironmentsId" };

/**
 * Represents the table public.environments
 * @uniqueConstraints {"environments_pkey":{"name":"environments_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"env_project_slug_unique":{"name":"env_project_slug_unique","isPrimary":false,"isUnique":true,"columns":[{"name":"project_id","definition":"project_id","predicate":null},{"name":"slug","definition":"slug","predicate":null}]},"env_project_name_unique":{"name":"env_project_name_unique","isPrimary":false,"isUnique":true,"columns":[{"name":"project_id","definition":"project_id","predicate":null},{"name":"name","definition":"name","predicate":null}]}}
 */
export default interface EnvironmentsTable {
  id: ColumnType<EnvironmentsId, EnvironmentsId | undefined, EnvironmentsId>;

  projectId: ColumnType<ProjectsId, ProjectsId, ProjectsId>;

  name: ColumnType<string, string, string>;

  slug: ColumnType<string, string, string>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;
}

export type Environments = Selectable<EnvironmentsTable>;

export type NewEnvironments = Insertable<EnvironmentsTable>;

export type EnvironmentsUpdate = Updateable<EnvironmentsTable>;

export const environmentsId = z.string() as unknown as z.Schema<EnvironmentsId>;

export const environments = z.object({
  id: environmentsId,
  projectId: projectsId,
  name: z.string(),
  slug: z.string(),
  createdAt: z.date(),
});

export const environmentsInitializer = z.object({
  id: environmentsId.optional(),
  projectId: projectsId,
  name: z.string(),
  slug: z.string(),
  createdAt: z.date().optional(),
});

export const environmentsMutator = z.object({
  id: environmentsId.optional(),
  projectId: projectsId.optional(),
  name: z.string().optional(),
  slug: z.string().optional(),
  createdAt: z.date().optional(),
});

// ── constraints for Environments ─────────────────────────────────
export const EnvironmentsConstraints = {
  environments_pkey: {
    name: "environments_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  env_project_slug_unique: {
    name: "env_project_slug_unique",
    isPrimary: false,
    isUnique: true,
    columns: [
      { name: "project_id", definition: "project_id", predicate: null },
      { name: "slug", definition: "slug", predicate: null },
    ],
  },
  env_project_name_unique: {
    name: "env_project_name_unique",
    isPrimary: false,
    isUnique: true,
    columns: [
      { name: "project_id", definition: "project_id", predicate: null },
      { name: "name", definition: "name", predicate: null },
    ],
  },
} as const;
export type EnvironmentsConstraintsType = typeof EnvironmentsConstraints;
